var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "banner imagebg-container",
          staticStyle: {
            height: "350px",
            "background-image":
              "url(/res/images/complaints/complaints-banner.jpg)",
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("h1", { staticClass: "big-caption" }, [
              _vm._v(_vm._s(_vm.bannerline1[_vm.getCurrentLocale])),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "med-caption yellow-color" }, [
              _vm._v(_vm._s(_vm.bannerline2[_vm.getCurrentLocale])),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sentSuccessful === false,
                    expression: "sentSuccessful === false",
                  },
                ],
                staticClass: "col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("div", { staticClass: "container shortcode travel-ideas" }, [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(0),
                    _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "sdr-box booking-section" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.welcome[_vm.getCurrentLocale]))]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.welcometext1[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.welcometext2[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.welcometext3[_vm.getCurrentLocale]),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "sdr-box booking-section" }, [
                  _c(
                    "form",
                    {
                      attrs: {
                        role: "form",
                        id: "complaints-form",
                        method: "post",
                        enctype: "multipart/form-data",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.onSubmit($event)
                        },
                      },
                    },
                    [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.personaldata[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.label_firstname[_vm.getCurrentLocale]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_firstname,
                                expression: "inputComplaint_firstname",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_firstname.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_firstname",
                              name: "inputComplaint_firstname",
                              placeholder:
                                _vm.placeholder_firstname[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_firstname },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_firstname =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_firstname.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_firstname.$dirty &&
                          !_vm.$v.inputComplaint_firstname.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_firstname.$dirty &&
                          !_vm.$v.inputComplaint_firstname.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_firstname[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_firstname.$dirty &&
                          !_vm.$v.inputComplaint_firstname.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_firstname[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_firstname.$dirty &&
                          !_vm.$v.inputComplaint_firstname.letterspaces
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_letterspaces[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_lastname[_vm.getCurrentLocale]) +
                                ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_lastname,
                                expression: "inputComplaint_lastname",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_lastname.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_lastname",
                              name: "inputComplaint_lastname",
                              placeholder:
                                _vm.placeholder_lastname[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_lastname },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_lastname =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_lastname.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_lastname.$dirty &&
                          !_vm.$v.inputComplaint_lastname.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_lastname.$dirty &&
                          !_vm.$v.inputComplaint_lastname.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_firstname[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_lastname.$dirty &&
                          !_vm.$v.inputComplaint_lastname.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_firstname[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_lastname.$dirty &&
                          !_vm.$v.inputComplaint_lastname.letterspaces
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_letterspaces[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_email[_vm.getCurrentLocale]) +
                                ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_email,
                                expression: "inputComplaint_email",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_email.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_email",
                              name: "inputComplaint_email",
                              placeholder:
                                _vm.placeholder_email[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_email },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_email = $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_email.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_email.$dirty &&
                          !_vm.$v.inputComplaint_email.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.inputComplaint_email.email
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(_vm.errmsg_email[_vm.getCurrentLocale])
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.label_emailrepeat[_vm.getCurrentLocale]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_emailrepeat,
                                expression: "inputComplaint_emailrepeat",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_emailrepeat.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_emailrepeat",
                              name: "inputComplaint_emailrepeat",
                              placeholder:
                                _vm.placeholder_emailrepeat[
                                  _vm.getCurrentLocale
                                ],
                            },
                            domProps: { value: _vm.inputComplaint_emailrepeat },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_emailrepeat =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_emailrepeat.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_emailrepeat.$dirty &&
                          !_vm.$v.inputComplaint_emailrepeat.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.inputComplaint_emailrepeat.email
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(_vm.errmsg_email[_vm.getCurrentLocale])
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_zip[_vm.getCurrentLocale]) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_zip,
                                expression: "inputComplaint_zip",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_zip.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_zip",
                              name: "inputComplaint_zip",
                              placeholder:
                                _vm.placeholder_zip[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_zip },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_zip = $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_zip.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_zip.$dirty &&
                          !_vm.$v.inputComplaint_zip.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_zip.$dirty &&
                          !_vm.$v.inputComplaint_zip.numeric
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_numeric[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_zip.$dirty &&
                          !_vm.$v.inputComplaint_zip.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_plz[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_zip.$dirty &&
                          !_vm.$v.inputComplaint_zip.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_plz[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_adress[_vm.getCurrentLocale]) +
                                ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_adress,
                                expression: "inputComplaint_adress",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_adress.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_adress",
                              name: "inputComplaint_adress",
                              placeholder:
                                _vm.placeholder_adress[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_adress },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_adress =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_adress.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_adress.$dirty &&
                          !_vm.$v.inputComplaint_adress.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.label_departuredate[_vm.getCurrentLocale]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_departuredate,
                                expression: "inputComplaint_departuredate",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid:
                                _vm.$v.inputComplaint_departuredate.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_departuredate",
                              name: "inputComplaint_departuredate",
                              placeholder:
                                _vm.placeholder_departuredate[
                                  _vm.getCurrentLocale
                                ],
                            },
                            domProps: {
                              value: _vm.inputComplaint_departuredate,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_departuredate =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_departuredate.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_departuredate.$dirty &&
                          !_vm.$v.inputComplaint_departuredate.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_flightno[_vm.getCurrentLocale]) +
                                ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_flightno,
                                expression: "inputComplaint_flightno",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_flightno.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_flightno",
                              name: "inputComplaint_flightno",
                              placeholder:
                                _vm.placeholder_flightno[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_flightno },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_flightno =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_flightno.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_flightno.$dirty &&
                          !_vm.$v.inputComplaint_flightno.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.label_departureairport[_vm.getCurrentLocale]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_departureairport,
                                expression: "inputComplaint_departureairport",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid:
                                _vm.$v.inputComplaint_departureairport.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_departureairport",
                              name: "inputComplaint_departureairport",
                              placeholder:
                                _vm.placeholder_departureairport[
                                  _vm.getCurrentLocale
                                ],
                            },
                            domProps: {
                              value: _vm.inputComplaint_departureairport,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_departureairport =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_departureairport.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_departureairport.$dirty &&
                          !_vm.$v.inputComplaint_departureairport.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.label_destinationairport[
                                  _vm.getCurrentLocale
                                ]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_destinationairport,
                                expression: "inputComplaint_destinationairport",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid:
                                _vm.$v.inputComplaint_destinationairport.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "inputComplaint_destinationairport",
                              name: "inputComplaint_destinationairport",
                              placeholder:
                                _vm.placeholder_destinationairport[
                                  _vm.getCurrentLocale
                                ],
                            },
                            domProps: {
                              value: _vm.inputComplaint_destinationairport,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_destinationairport =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_destinationairport.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_destinationairport.$dirty &&
                          !_vm.$v.inputComplaint_destinationairport.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-md-10" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.label_remark[_vm.getCurrentLocale]) +
                                ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputComplaint_remark,
                                expression: "inputComplaint_remark",
                              },
                            ],
                            staticClass: "full-width",
                            class: {
                              invalid: _vm.$v.inputComplaint_remark.$error,
                            },
                            attrs: {
                              rows: "10",
                              id: "inputComplaint_remark",
                              name: "inputComplaint_remark",
                              placeholder:
                                _vm.placeholder_remark[_vm.getCurrentLocale],
                            },
                            domProps: { value: _vm.inputComplaint_remark },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputComplaint_remark =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputComplaint_remark.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputComplaint_remark.$dirty &&
                          !_vm.$v.inputComplaint_remark.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-md-10" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              staticStyle: {
                                "text-transform": "none",
                                "font-weight": "bold",
                                "font-size": "13px",
                              },
                              attrs: { for: "files" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.label_file[_vm.getCurrentLocale])
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileinput",
                            attrs: {
                              type: "file",
                              accept: "application/pdf",
                              id: "fileinput",
                              name: "fileinput",
                              "data-max-size": "5096",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("div", {
                            staticClass: "g-recaptcha",
                            attrs: {
                              "data-sitekey":
                                "6LexCygUAAAAAI5T46BeunRODXgfnj3rykC7jp3Y",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.checkValidity()
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "button btn-large uppercase full-width silver",
                                  staticStyle: { "margin-top": "10px" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.send_request[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkValidity()
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-large icon-check uppercase full-width",
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.send_request[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sentSuccessful === true,
                    expression: "sentSuccessful === true",
                  },
                ],
                staticClass: "col-sm-8 col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("div", { staticClass: "container shortcode travel-ideas" }, [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(1),
                    _vm._v(_vm._s(_vm.wasssentsuccesful[_vm.getCurrentLocale])),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }